import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider, useTheme } from "@/lib/theme";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import WhmServers from "@/pages/WhmServers";
import PdnsServers from "@/pages/PdnsServers";
import Zones from "@/pages/Zones";
import Queue from "@/pages/Queue";
import Events from "@/pages/Events";
import Alerts from "@/pages/Alerts";
import ContentAlerts from "@/pages/ContentAlerts";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import ApiKeys from "@/pages/ApiKeys";
import Layout from "@/components/Layout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground text-sm font-mono animate-pulse" data-testid="auth-loading">yükleniyor...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return <Layout>{children}</Layout>;
}

// Yalnız süper admin (API anahtarları + Kullanıcı yönetimi). Admin/viewer → ana sayfaya.
function SuperOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "superadmin") return <Navigate to="/" replace />;
  return children;
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster position="top-right" theme={theme} richColors closeButton />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <ThemedToaster />
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/whm" element={<Protected><WhmServers /></Protected>} />
          <Route path="/pdns" element={<Protected><PdnsServers /></Protected>} />
          <Route path="/zones" element={<Protected><Zones /></Protected>} />
          <Route path="/queue" element={<Protected><Queue /></Protected>} />
          <Route path="/events" element={<Protected><Events /></Protected>} />
          <Route path="/alerts" element={<Protected><Alerts /></Protected>} />
          <Route path="/content" element={<Protected><ContentAlerts /></Protected>} />
          <Route path="/users" element={<Protected><SuperOnly><Users /></SuperOnly></Protected>} />
          <Route path="/park" element={<Protected><SuperOnly><ApiKeys /></SuperOnly></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
